// extracted by mini-css-extract-plugin
export var item = "graph-col-module--item--2_BGx";
export var item_front = "graph-col-module--item_front--MaJwc";
export var item_back = "graph-col-module--item_back--Qgw6o";
export var animate = "graph-col-module--animate--3SDcp";